import React, {useState, useEffect} from 'react';
import {sortBy} from 'lodash';
import {getSubscriptionPlans} from "../../services/api.service";
import {SkeletonLoader} from '../../Component/SkeletonLoader';
import Plan from './Plan';
import {useRecoilValue} from "recoil";
import {userData} from "../../recoil_store";
import './Payment.css';

const Payment = () => {
    const [plansList, setPlansList] = useState([]);
    const [divLoading, setDivLoaders] = useState(false);
    const {subscriptions, loading} = useRecoilValue(userData)

    useEffect(() => {
        setDivLoaders(loading)
    }, [loading])

    useEffect(() => {
        getPlans();//init call
    }, []);

    const getPlans = async () => {
        try {
            setDivLoaders(true);
            const {data: {data}} = await getSubscriptionPlans();
            const sortedData = sortBy(data.filter(item => item.amount), ['amount']);
            setPlansList(sortedData);
            // setDivLoaders(false);
        } catch (err) {
            setDivLoaders(false);
        }
    };

    return (
        <React.Fragment>
            <section className="pricing py-5 payment-page">
                <div className="container">
                    {divLoading ? <SkeletonLoader/> : (
                        <div className="row">
                            {
                                plansList.map((subs, key) => subscriptions.subscriptionPlan !== subs.id &&
                                    (
                                        <div className="col-lg-4" key={key + 1}>
                                            <Plan subs={subs}/>
                                        </div>
                                    ))
                            }
                        </div>
                    )}
                </div>
            </section>
        </React.Fragment>
    )
};

export default Payment;